const RADSideMenu = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rad.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-home-4-line'
  },
  {
    title: 'Pending Approvals',
    is_heading: false,
    is_active: false,
    link: {
      name: 'rad.pending-approvals'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-currency-line'
  },
  {
    title: 'Reports',
    name: 'sidebar.reports',
    is_heading: false,
    is_active: false,
    link: '',
    class_name: '',
    is_icon_class: true,
    icon: 'ri-folder-chart-line',
    children: [
      {
        title: 'Approval Histories',
        is_active: false,
        link: {
          name: 'rad.approval-histories'
        },
        class_name: '',
        is_icon_class: true,
        icon: 'ri-file-excel-2-line'
      }
    ]
  }
]

export default RADSideMenu
